// @docs https://[domain]/api/v1/docs
export default {
  List: "/titles",
  Detail: "/titles",
  Update: "/titles",
  Create: "/titles",
  ListShort: "/titles/short",
};
